<template>
	<modal-dialog
		class="form-modal"
		title="Company Form"
		:modal-visible="visible"
		confirm-button-text="Submit"
		button-class="btn-success"
		:submit-visible="false"
		modal-size="modal-lg"
		ref="modal"
		v-on:closeModal="promptClose = true">

		<div v-show="promptClose" class="text-center">

			<p>Are you sure you want to exit?</p>

			<button class="btn btn-light" v-on:click="promptClose = false">
				Ok, Continue with Form
			</button>
			<button class="btn btn-outline-danger" v-on:click="confirmCloseForm">
				Yes, Cancel Form
			</button>
		</div>
		<div v-show="!promptClose" class="modal-content-container">
			<template v-if="childTemplate && childTemplate.FormTemplate.has_equipment == 1">
				<field v-if="formRecord && 'id' in formRecord && equipment_id > 0"
					label="Equipment"
					col-class="col-md-4"
					:value="'Equipment' in formRecord && formRecord.Equipment ? formRecord.Equipment.description : '[none selected]'"
					:readonly="true">
				</field>
				<form-group v-else 
					label="Equipment"
					col-class="col-md-4">

					<equipment-picker
						v-model="equipment_id"
						:allowed-type-ids="allowedEquipmentTypeIds"
						:hide-meta="true">		
					</equipment-picker>

				</form-group>
			</template>

			<form-fillable v-if="childTemplate && childTemplate.FormTemplate.has_equipment == 0 || equipment_id > 0"
				v-model="formSections"
				:form-is-active="true"
				:acknowledgements="acknowledgements"
				:readonly="formRecord && 'id' in formRecord && !isResubmit"
				:no-participant-controls="isSingleUseLocal"
				:project="projectId > 0 ? $store.project : false"
				:service="serviceId > 0 ? $store.service : false"
				:skip-form="skipForm"
				v-on:submit="submitForm">
			</form-fillable>
			
		</div>

	</modal-dialog>
</template>
<script type="text/javascript">
import FormFillable from "@/components/company_forms/FormFillable"
import FormStaticRender from "@/components/company_forms/FormStaticRender"

import ModalDialog from "@/components/ModalDialog"
import EquipmentPicker from "@/components/equipment_picker/EquipmentPicker"
import FormGroup from "@/components/FormGroup"
import Field from "@/components/Field"

import FormMixins from "@/mixins/FormMixins"

export default {
	name: "CompanyFormModal",
	components: {
		ModalDialog,
		FormFillable,
		EquipmentPicker,
		FormGroup,
		Field,
		FormStaticRender
	},
	mixins: [FormMixins],
	props: [
		"visible",
		"formId",
		"childTemplateId",
		"projectId",
		"serviceId",
		"serviceWorksheetId",
		"customerAssetId",
		"isSingleUse",          //if true, form will auto-activate, then close itself on save so only 1 person can acknowledge the form
		"isPunchIn",    // was this form instantiated by a user punching into a project/service?
		"isResubmit",				// if formId is set and isResubmit is true, we fetch from the formId, but create new records on submission
		"isRequired"    // prevent users from exiting the form once started. Requires that childTemplateId is also set.  Value is automatically true if the form is a punch-in form and marked as required
	],
	data() {
		return {
			formRecord: null,
			formSections: [],
			acknowledgements: [],
			equipment_id: null,
			childTemplate: null,
			promptClose: false,
			allowedEquipmentTypeIds: null
		}
	},
	watch: {
		visible() {
			if (this.visible)
				this.fetchForm(true)
		},
	},
	computed: {
		skipForm() {
			// True if the viewing reader has already signed the form

			if (!this.acknowledgements || this.isResubmit)
				return false

			let userAck = this.acknowledgements.find(ack => 'user_id' in ack && ack.user_id == this.$store.userDetails.id)
			return userAck && 'signature_json' in userAck && userAck.signature_json
		},
		isSubmitRequired() {
			// True if this form was initiated by a user punching into a job/service, AND the corresponding field is set to true
			return (this.childTemplate) &&
				(this.isRequired ||
					((this.isPunchIn) &&
						((this.projectId && 'clockin_prompt_projects_required' in this.childTemplate && this.childTemplate.clockin_prompt_projects_required) ||
						 (this.serviceId && 'clockin_prompt_services_required' in this.childTemplate && this.childTemplate.clockin_prompt_services_required))))
		},
		isSingleUseLocal() {
			if (this.isSingleUse)
				return true
			else if (this.childTemplate && "FormTemplate" in this.childTemplate && this.childTemplate.FormTemplate && this.childTemplate.FormTemplate.is_single_use == 1) 
				return true

			return false
		}
	},
	methods: {
		confirmCloseForm() {
			this.promptClose = false
			this.$emit('closeModal')
		},
		init() {
			let vm = this
			if (this.formId)
				this.fetchForm(true)
			else if (this.childTemplateId) {
				this.fetchChildTemplate(this.childTemplateId,true).then(response =>{
					//create a log entry for this user filling out a form
					if (response.success) {
						vm.postData("CompanyForm/start-log",{
							form_child_template_id: response.data.id,
							template_title: response.data.FormTemplate.title,
							child_template_description: response.data.description
						})
					}
				})
			}
		},
		submitForm(form) {
			let vm = this

			//compile responses
			
			let payload = {
				form_json: JSON.stringify(form.formSections.filter(section => !('isCompleteSection' in section) || !section.isCompleteSection)),
				child_template_id: this.childTemplateId
			}

			if (this.serviceId > 0)
				payload.service_id = this.serviceId
			else if (this.projectId > 0)
				payload.job_id = this.projectId

			if (this.equipment_id)
				payload.equipment_id = this.equipment_id

			if (this.formId && !this.isResubmit)
				payload.id = this.formId

			if (this.serviceWorksheetId)
				payload.worksheet_id = this.serviceWorksheetId

			if (this.customerAssetId)
				payload.customer_asset_id = this.customerAssetId

			this.postData("CompanyForm/save",payload,true).then(response => {
				if (response.success || vm.formId) {
					let fields = ["id","form_id","user_id","is_external_worker","name","phone","email","company_name","signature_json","form_json","is_invite"]

					vm.$bus.$emit("companyFormSaved",{
						record_id: response.data.record_id,
						payload
					})

					vm.postData("ErrorLog/save",{
						user_id: vm.$store.userDetails.id,
						endpoint: "Front End",
						user_error_message: "Company Form save",
						payload_json: JSON.stringify(response),
						tenant_id: vm.$store.userDetails.tenant_id,
						user_agent: navigator.userAgent
					})

					let records = form.participants.filter(part => !('id' in part)).map(part => {
							part.form_id = response.data.record_id
							part.form_json = payload.form_json

							let record = {}
							fields.forEach(key => {
								record[key] = part[key]
							})

							return record
						})

					if (records.length == 0) {
						vm.alertFail("Form saved, but there were no participants added. code: 002a")

						vm.postData("ErrorLog/save",{
							user_id: vm.$store.userDetails.id,
							endpoint: "Front End",
							user_error_message: "Form save -- no participants sent",
							payload_json: JSON.stringify(form.participants),
							tenant_id: vm.$store.userDetails.tenant_id,
							user_agent: navigator.userAgent
						})
					}
					else {
						let ackBatchPayload = {
							records: JSON.stringify(records)
						}

						vm.postData("CompanyFormAcknowledgement/save-batch",ackBatchPayload,true).then(ackResponse => {

							vm.postData("ErrorLog/save",{
								user_id: vm.$store.userDetails.id,
								endpoint: "Front End",
								user_error_message: "Form acknowledgement save: response: "+JSON.stringify(records),
								payload_json: JSON.stringify(ackBatchPayload),
								tenant_id: vm.$store.userDetails.tenant_id,
								user_agent: navigator.userAgent
							})

							if (ackResponse.success) {

								if (ackResponse.data.records_saved > 0) {
									let recordIds = ackResponse.data.records_saved_list.join(", ")

									vm.alertSaved("Form saved with "+records.length+" participants! ("+this.moment.utc().format("YYYY-MM-DD HH:mm:ss")+"). Signature record ids: "+recordIds,false)

									vm.$bus.$emit("companyFormParticipantsSaved",{
										record_id: ackResponse.data.records_saved,
										payload
									})
								}
								else {
									vm.alertFail("Form saved but no participants were recorded! ("+this.moment.utc().format("YYYY-MM-DD HH:mm:ss")+") code: 001a",false)
								}

								vm.$emit('closeModal')
							}
							else
								vm.alertFail("Form saved but no participants were recorded! ("+this.moment.utc().format("YYYY-MM-DD HH:mm:ss")+") code: 001b",false)
						})
					}
				}
			})
		},
		fetchChildTemplate(childTemplateIdOrSlug,spinner) {
			let vm = this

			let params = {
				include: [
					{
						model: "FormTemplate",
						include: [{model: "EquipmentType",fields:["id"]}]
					}
				]
			}

			if (spinner)
				vm.spinner(true)

			return new Promise((resolve,reject) => {

				vm.getJSON("FormChildTemplate/find/"+childTemplateIdOrSlug,params,true).then(response => {
					if (response.success) {
						vm.childTemplate = response.data

						try {
							vm.formSections = JSON.parse(response.data.form_json)
						}
						catch (e) {
							vm.formSections = []
						}

						if ("EquipmentType" in response.data.FormTemplate && response.data.FormTemplate.EquipmentType.length > 0)
							vm.allowedEquipmentTypeIds = response.data.FormTemplate.EquipmentType.map(item => +item.id)
						else
							vm.allowedEquipmentTypeIds = false

					}

					if (spinner)
						vm.spinner(false)

					resolve(response)
				})
			})
		},
		fetchForm(spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			let params = {
				include: [
					{
						model: "FormChildTemplate",
						include: ["FormTemplate"]
					},
					{
						model: "Equipment",
						fields: ["id","slug","description"]
					},
					"CompanyFormAcknowledgement"
				]
			}

			this.getJSON("CompanyForm/find/"+this.formId,params).then(response => {
				if (spinner)
					this.spinner(false)

				if (response.success) {
					try {
						vm.formSections = JSON.parse(response.data.form_json)
					}
					catch (ex) {
						vm.formSections = []
					}

					vm.childTemplate = response.data.FormChildTemplate
					vm.equipment_id = response.data.equipment_id
					vm.isActive = response.data.is_deactivated == 0 && (!response.data.expiry || vm.moment.utc(response.data.expiry).isAfter(vm.moment())) ? true : false

					if ('CompanyFormAcknowledgement' in response.data)
						vm.acknowledgements = response.data.CompanyFormAcknowledgement
					else
						vm.acknowledgements = []

					// make sure to refresh acknowledgements and clear signature if this is a resubmit
					if (vm.isResubmit) {

						let allowedFields = ['name', 'email', 'phone', 'company_name', 'user_id', 'is_external_worker','is_invite']

						vm.acknowledgements = vm.acknowledgements
							.filter(ack => 'user_id' in ack && ack.user_id != vm.$store.userDetails.id)
							.map(ack => {
								Object.keys(ack).forEach(key => {
									if (!allowedFields.includes(key))
										delete ack[key]
								})

								return ack
							})

					}

					//push an empty section so we can show completed screen
					/*if (!vm.formSections.find(section => "isCompleteSection" in section && section.isCompleteSection))
						vm.formSections.push({sectionHeading:"Complete!",fields:[],isCompleteSection:true})
					*/
					vm.formRecord = response.data
				}
			})
		}
	},
	created() {
		this.init()
		let vm = this
	}
}
</script>

<style scoped>

	section {
		width: 100%;
	}

	section h5 {
		font-size: 16pt;
	}

	section pre {
		font-size: 16pt;
		font-family: inherit;
		margin-bottom: 5px;
	}

	.field {
		padding: 5px;
		z-index: 5;
		background-color: #fff;
		font-size: 16pt;
	}

	.field:nth-child(even) {
		background-color: #f7f8f9
	}

</style>